const SEARCH_DEBOUNCE_MS = 180;

const debounce = (callback, delay = SEARCH_DEBOUNCE_MS) => {
  let timeoutId;

  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => callback(...args), delay);
  };
};

const getPredictiveSearchUrl = (term) => {
  const predictiveSearchPath = window.Theme?.routes?.predictive_search_url || '/search/suggest';
  const url = new URL(predictiveSearchPath, window.location.origin);

  url.searchParams.set('q', term);
  url.searchParams.set('resources[limit_scope]', 'each');
  url.searchParams.set('section_id', 'predictive-search');

  return url;
};

const extractResultsMarkup = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const results = doc.querySelector('#predictive-search-results');

  return results?.outerHTML || '';
};

const neutralizeResultText = (results) => {
  results.style.setProperty('color', '#111', 'important');
  results.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');

  results.querySelectorAll(`
    .predictive-search-results__title,
    .predictive-search-results__pill,
    .predictive-search-results__pill *,
    .predictive-search-results__card,
    .predictive-search-results__card *,
    .resource-card,
    .resource-card *,
    .price,
    .price *,
    [class*="price"],
    [class*="price"] *
  `).forEach((element) => {
    if (!(element instanceof HTMLElement)) return;
    element.style.setProperty('color', '#111', 'important');
    element.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    element.style.setProperty('text-shadow', 'none', 'important');
  });

  results.querySelectorAll('.compare-at-price, .price__was, s').forEach((element) => {
    if (!(element instanceof HTMLElement)) return;
    element.style.setProperty('color', '#555', 'important');
    element.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    element.style.setProperty('opacity', '1', 'important');
    element.style.setProperty('text-shadow', 'none', 'important');
  });
};

const initHeaderSearch = (form) => {
  const input = form.querySelector('input[type="search"]');
  const results = form.querySelector('[data-bz-header-search-results]');

  if (!(input instanceof HTMLInputElement) || !(results instanceof HTMLElement)) return;

  let activeController;

  const hideResults = () => {
    results.hidden = true;
    results.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  };

  const showResults = (markup) => {
    if (!markup) {
      hideResults();
      return;
    }

    results.innerHTML = markup;
    neutralizeResultText(results);
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  };

  const fetchResults = debounce(async () => {
    const term = input.value.trim();

    if (!term) {
      hideResults();
      return;
    }

    activeController?.abort();
    activeController = new AbortController();

    try {
      const response = await fetch(getPredictiveSearchUrl(term), { signal: activeController.signal });
      const html = await response.text();

      if (activeController.signal.aborted) return;

      showResults(extractResultsMarkup(html));
    } catch (error) {
      if (error.name !== 'AbortError') hideResults();
    }
  });

  input.addEventListener('input', fetchResults);
  input.addEventListener('focus', () => {
    if (input.value.trim() && results.innerHTML.trim()) {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
  });

  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hideResults();
  });

  document.addEventListener('click', (event) => {
    if (event.target instanceof Node && !form.contains(event.target)) {
      hideResults();
    }
  });
};

document.querySelectorAll('.bz-naturalist-header-search').forEach(initHeaderSearch);
